(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var els = document.querySelectorAll('.reveal');
  if (!els.length) return;

  // "$3.4B" -> prefix "$", number 3.4, suffix "B"; "158,000" keeps its commas.
  function countUp(el) {
    var m = el.textContent.trim().match(/^([^0-9]*)([0-9][0-9,]*\.?[0-9]*)(.*)$/);
    if (!m || reduce) return;
    var target = parseFloat(m[2].replace(/,/g, '')), decimals = (m[2].split('.')[1] || '').length;
    var commas = m[2].indexOf(',') > -1, start = null, dur = 1600;
    function fmt(v) {
      var t = v.toFixed(decimals);
      return commas ? Number(t).toLocaleString('en-US', { minimumFractionDigits: decimals, maximumFractionDigits: decimals }) : t;
    }
    el.setAttribute('aria-label', el.textContent.trim());
    function step(ts) {
      if (start === null) start = ts;
      var p = Math.min((ts - start) / dur, 1), e = 1 - Math.pow(1 - p, 4);
      el.textContent = m[1] + fmt(target * e) + m[3];
      if (p < 1) requestAnimationFrame(step); else el.textContent = m[1] + m[2] + m[3];
    }
    el.textContent = m[1] + fmt(0) + m[3];
    requestAnimationFrame(step);
  }

  function show(el) {
    el.classList.add('in');
    el.querySelectorAll('[data-count]').forEach(function (n) {
      var delay = parseFloat((el.style.getPropertyValue('--d') || '0')) * 1000;
      setTimeout(function () { countUp(n); }, delay + 150);
    });
  }

  if (!('IntersectionObserver' in window) || reduce) { els.forEach(function (el) { el.classList.add('in'); }); return; }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) { if (en.isIntersecting) { show(en.target); io.unobserve(en.target); } });
  }, { threshold: 0.18, rootMargin: '0px 0px -6% 0px' });
  els.forEach(function (el) { io.observe(el); });
})();
